import { useEffect } from 'react';
import { FAVORITES_STORAGE_KEY } from '../../../constants';
import { decodeBackup } from '../utils/createBackupLink';

function removeQueryFromUrl() {
  const cleanUrl = window.location.pathname + window.location.hash;
  window.history.replaceState(null, '', cleanUrl);
}

/**
 * Se a página abrir com ?backup=..., pede confirmação, grava a carteira
 * no localStorage e recarrega a página sem o parâmetro.
 */
export function useRestoreBackupFromUrl() {
  useEffect(() => {
    const backup = new URLSearchParams(window.location.search).get('backup');

    if (!backup) return;

    if (!window.confirm('Pressione OK para confirmar o Backup')) {
      removeQueryFromUrl();
      return;
    }

    try {
      localStorage.setItem(FAVORITES_STORAGE_KEY, decodeBackup(backup));
      console.log('Backup restaurado com sucesso!');
    } catch (err) {
      console.error('Erro ao restaurar backup:', err);
    }

    removeQueryFromUrl();
    window.location.reload();
  }, []);
}
